import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { ExtratoContaOrbitalService } from './extrato-conta-orbital.service';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-extrato-conta-orbital',
  templateUrl: './extrato-conta-orbital.component.html',
  styleUrls: ['./extrato-conta-orbital.component.scss']
})
export class ExtratoContaOrbitalComponent implements OnInit {

  @ViewChild('myTable', null)
  private myTable: DatatableComponent;

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public formExtratoContaOrbital = null;
  public extratoLote = null;
  public extrato = null;
  public rowData = null;
  public columnsTabe = null;
  public tableLimit = 20;
  public listTipoConta = null;
  public cnpjCpf = null;
  public saldoConta = null;
  public customLogin = null;



  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",

  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: ExtratoContaOrbitalService,
    private dateUtilService: DateUtilService,
    private exportCsvService: ExportCsvService,
    private router: Router,
    private notificationService: NotificationsService,
    private datatableService: DatatableService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listTipoConta = [
      {
        tipoConta: 'TOP_PESSOA',
        descricao: 'TOP PESSOA'
      },
      {
        tipoConta: 'TOP_EMPRESA',
        descricao: 'TOP EMPRESA'
      },

    ];

    this.formExtratoContaOrbital = this.formBuilder.group({
      saldoConta: [null],
      dataInicio: [null],
      dataFim: [null],
      tipoConta: [null, Validators.required],
      identificador: [null, Validators.required],
    });

    this.columnsTabe = [
      { columnName: "data", newColumnName: "Data" },
      { columnName: "descricao", newColumnName: "Descricao" },
      { columnName: "valor", newColumnName: "Valor" },
    ]

  }

  buscarExtrato(data?: any, page?: string) {

    let params = new HttpParams();

    if (data.tipoConta === null) {
      this.notificationService.error('Campo Tipo da Conta é obrigatório!');
    } else if (data.identificador === null) {
      this.notificationService.error('Campo Identificador é obrigatório!');
    } else {

      if (data.tipoConta != null) {
        params = params.append('tipoConta', data.tipoConta)
      }
      if (data.identificador != null && String(data.identificador).trim() !== '') {
        params = params.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(data.identificador));
      }
      if (data.dataInicio != null) {
        let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
        params = params.append('dataInicio', dataInicio)
      }
      if (data.dataFim != null) {
        let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
        params = params.append('dataFim', dataFim)
      }

      params = params.append('size', String(this.tableLimit))

      if (page) {
        params = params.append('page', page)
      }

      this.service.buscaExtratoOrbital(params, (response => {

        this.rowData = response.content
        this.extrato = response.content.length;
        this.rowData = this.rowData.map(data => {
          return {
            data: this.dateUtilService.formatDate(data.data, "DD-MM-YYYY"),
            descricao: data.descricao,
            valor: data.valor
          }
        })

        this.paginationService.setInfo(response)

        if (this.extrato == 0) {
          this.notificationService.warn('Não há dados nesse período!');
        }

      }), null);

    }


  }

  buscarExtratoTotal(data?: any) {

    let params = new HttpParams();

    params = params.append('allElements', 'true');

    params = params.append('size', String(999999999))

    if (data.tipoConta === null) {
      this.notificationService.error('Campo Tipo da Conta é obrigatório!');
    } else if (data.identificador === null) {
      this.notificationService.error('Campo Identificador é obrigatório!');
    } else {

      if (data.tipoConta != null) {
        params = params.append('tipoConta', data.tipoConta)
      }
      if (data.identificador != null && String(data.identificador).trim() !== '') {
        params = params.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(data.identificador));
      }
      if (data.dataInicio != null) {
        let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
        params = params.append('dataInicio', dataInicio)
      }
      if (data.dataFim != null) {
        let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
        params = params.append('dataFim', dataFim)
      }

      this.service.buscaExtratoOrbital(params, (response => {

        this.rowData = response.content
        this.extrato = response.content.length;

        this.rowData = this.rowData.map(data => {
          return {
            data: moment(data.data).format('DD/MM/YYYY HH:mm'),
            descricao: data.descricao,
            valor: data.valor,
          }
        })

        if (this.extrato == 0) {
          this.notificationService.warn('Não há dados para exportar!');
        }

        this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ',', 'extratoObital');

      }), null);

    }

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.saldoConta = 0;
    this.datatableService.subscribeTable(this.myTable);

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
